// Swaps the chain-necklace nudge's thumbnail (and its zoom-modal preview) to match the currently
// selected birth month, using each necklace product's own real photos — no separate image upload
// needed. Purely decorative: this never changes what gets added to cart, so unlike a full add-to-cart
// flow there's no SKU-accuracy risk if this mapping is ever slightly behind the catalog, only a stale
// photo. Listens sitewide (bubbled event) but is a harmless no-op anywhere the nudge element isn't
// present.
(function () {
  function updateImages(monthValue) {
    var nudge = document.querySelector('.chain-necklace-nudge');

    if (!nudge) {
      return;
    }

    var mapJson = nudge.getAttribute('data-necklace-images');

    if (!mapJson || !monthValue) {
      return;
    }

    var map;

    try {
      map = JSON.parse(mapJson);
    } catch (error) {
      return;
    }

    var entry = map[monthValue];

    if (!entry) {
      return;
    }

    var smallImg = nudge.querySelector('.chain-necklace-nudge__image');
    var largeImg = nudge.querySelector('.chain-necklace-nudge__zoom-image');

    if (smallImg && entry.small) {
      smallImg.src = entry.small;
    }

    if (largeImg && entry.large) {
      largeImg.src = entry.large;
    }
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;

    if (variant && variant.option1) {
      updateImages(variant.option1);
    }
  });
})();
